export interface NumberRange {
  max: number
  min: number
}

export function isNumberInRange(value: number, range: NumberRange) {
  const { min, max } = range
  return value >= min && value <= max
}
